<template>
  <v-container
    fluid
    fill-height
    class="no-pad"
  >
    <NoneOutstanding v-if="!loading && markers.length < 1" />
    <v-layout
      align-space-around
      justify-center
      column
      fill-height
    >
      <div v-if="loading">
        <v-flex>
          <h3>Loading...</h3>
        </v-flex>
        <v-flex>
          <v-progress-circular
            :size="50"
            color="secondary"
            indeterminate
          />
        </v-flex>
      </div>
      <v-flex class="map-container">
        <prime-google-map
          :pipes="pipes"
          :loggers="loggers"
          :markers="markers"
          :active-pipes="activePipes"
          @marker-click="onMarkerClick"
        />
        <v-btn
          color="primary"
          dark
          absolute
          bottom
          left
          fab
          class="custom"
          @click="sheet = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-bottom-sheet v-model="sheet">
      <v-list
        dark
        class="primeweb darken-3"
      >
        <v-list-tile @click="onDataButton">
          <v-list-tile-avatar>
            <v-avatar
              size="42px"
              color="primary"
            >
              <v-icon color="white">
                mdi-chart-line
              </v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>Details</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="onHideLoggersButton">
          <v-list-tile-avatar>
            <v-avatar
              size="42px"
              color="primary"
            >
              <v-icon
                v-if="showLoggers"
                color="white"
              >
                mdi-map-marker-off
              </v-icon>
              <v-icon
                v-else
                color="white"
              >
                mdi-map-marker
              </v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title v-if="showLoggers">
            Hide Loggers
          </v-list-tile-title>
          <v-list-tile-title v-else>
            Show Loggers
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="onHidePipesButton">
          <v-list-tile-avatar>
            <v-avatar
              size="42px"
              color="primary"
            >
              <PipeCancelIcon v-if="showPipes" />
              <v-icon
                v-else
                color="white"
              >
                mdi-pipe
              </v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title v-if="showPipes">
            Hide Pipes
          </v-list-tile-title>
          <v-list-tile-title v-else>
            Show Pipes
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import PipeCancelIcon from "../Icons/PipeCancel";
import { mapGetters } from "vuex";
import NoneOutstanding from "../components/Overlays/NoneOutstanding";
import { Logger, Pipe, GenericMarkerData } from "@primayer/prime-google-map";
import { ContentRoot, ContentPaths, OrangeMapIcons } from "../config/content";
export default {
  name: "OutstandingMap",
  components: {
    PipeCancelIcon,
    NoneOutstanding
  },
  data() {
    return {
      sheet: false,
      showLoggers: true,
      showPipes: true,
      localPipes: [],
      localLoggers: [],
      poiArray: [],
      localPois: [],
      pois: null
    };
  },

  computed: {
    ...mapGetters("login", {
      userId: "userId"
    }),
    pipes() {
      if (this.showPipes) {
        if (this.localPipes.length < 1) {
          this.makeLocalPipes();
        }
        return this.localPipes;
      }
      return [];
    },
    activePipes() {
      // todo:
      return [];
    },
    loggers() {
      if (this.showLoggers) {
        if (this.localLoggers.length < 1) {
          this.makeLocalLoggers();
        }
        return this.localLoggers;
      }
      return [];
    },
    markers() {
      if (this.pois) {
        if (this.localPois.length < 1) {
          this.makeLocalPois();
        }
        return this.localPois;
      }
      return [];
    },
    loading() {
      return false;
    }
  },
  methods: {
    onMarkerClick(event, value) {
      this.$router.push({ name: "mapDetail", params: { id: value.id } });
    },
    onDataButton() {
      this.$router.push({
        name: "outstanding",
        params: { id: this.$route.params.id }
      });
    },
    onHideLoggersButton() {
      this.showLoggers = !this.showLoggers;
    },
    onHidePipesButton() {
      this.showPipes = !this.showPipes;
    },
    makeLocalPipes() {
      if (this.mapData && this.mapData.pipes) {
        let pipes = [];
        this.mapData.pipes.forEach(p => {
          pipes.push(
            new Pipe({
              Id: p.id,
              Colour: p.colour,
              Coords: p.coords,
              Enabled: p.enabled
            })
          );
        });
        this.localPipes = pipes;
      }
    },
    makeLocalLoggers() {
      if (this.mapData && this.mapData.loggers) {
        let loggers = [];
        this.mapData.loggers.forEach(l => {
          loggers.push(new Logger({ ...l, useMaterialIcon: true }));
        });
        this.localLoggers = loggers;
      }
    },
    makeLocalPois() {
      if (this.pois) {
        let pois = [];
        this.pois.forEach(p => {
          let imageName =
            p.pointOfInterestCount <= 1
              ? OrangeMapIcons.poi
              : OrangeMapIcons.poiGroup;
          let url = `${ContentRoot}${ContentPaths.icons}${imageName}`;
          let icon = {
            url: url,
            size: [30, 30],
            origin: [0, 0],
            anchor: [15, 15]
          };
          pois.push(
            new GenericMarkerData({
              id: p.id,
              name: p.name,
              latitude: p.pointOfInterests[0].latitude,
              longitude: p.pointOfInterests[0].longitude,
              icon,
              label: p.pointOfInterestCount.toString()
            })
          );
        });
        this.localPois = pois;
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  height: 93vh;
}

.v-btn--bottom.v-btn--absolute.v-btn--small.custom {
  bottom: 4vh;
}

.v-btn--bottom.v-btn--absolute.custom {
  bottom: 4vh;
}
</style>
